import { AfterViewInit, Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { ClientService } from '../../../services/client.service';
import { AdminTiketService } from '../../../services/admin-tiket.service';
import { environment } from '../../../../environments/environment';
import { TicketService } from '../../../services/ticket.service';
import {NgbModal, NgbModalRef, ModalDismissReasons, NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import { InfoModalComponent } from '../../../shared/info-modal.component';
import { ModalComponent } from '../../../shared/modal.component';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { Observable, of, pipe, throwError } from 'rxjs';
import { mergeMap, map, switchMap, debounceTime, catchError } from 'rxjs/operators';
import { CodeService } from 'src/app/services/code.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DomSanitizer } from '@angular/platform-browser';
import { CLIENT_PLACEHOLDER, SUBJECT_MATTER_PLACEHOLDER } from '../../../shared/ticket-display';
import { apiErrorMessage, oversizedFileMessages } from '../../../shared/upload-limits';

import * as jquery from 'jquery';

declare var $: any;



class MetaFile {
  public id: number;
  public name: string;
  public filename: string;
  public uploaded_at: number;
  public userName: string;
  constructor(filename: string) {
    this.filename = filename;
  }
}

@Component({
    selector: 'app-edit-ticket',
    templateUrl: './edit-ticket.component.html',
    styleUrls: ['./edit-ticket.component.scss'],
    standalone: false
})

export class EditTicketComponent implements  OnInit {
  id: any;
  form: UntypedFormGroup;
  submitted = false;
  subject: any;
  username: any;
  useremail: any;
  created_at: any;
  conversation: any;
  file_data: Array<any>;
  metaFiles: MetaFile[] = [];
  files: Array<any> = null;
  curr_user_id: any;
  token: any;
  clients: any;
  users: any;
  subjects: any;
  // Shows an empty subject matter option when the ticket's is missing and no "Not Defined" code exists.
  subjectMatterMissing = false;
  // The ticket's own subject matter record, or null when it no longer exists.
  private ticketSubjectMatter: any = null;
  private ticketLoaded = false;
  clientMissing = false;
  requesterMissing = false;
  requesterUserId: any = null;
  requesterFullName = '';
  assignedUser: any;
  type: any = 1;
  btnText: any = 'Submit';
  default_status: any = 1;
  default: any = 0;
  company_name: any;
  company_info: any;
  avatar: any;
  modal: NgbModalRef;
  custom_image_title: any = '';
  fileErrors: string[] = [];
  submitError = '';
  showloader: boolean;
  userType: number;
  keywords: any;
  dropdownList = [];
  CCemailList = [];
  agentCCemailList = [];
  dropdownSettings = {};
  CCdropdownSettings = {};
  agentCCdropdownSettings = {};
  agentCC = '';
  clientCC = '';
  clientCCSelected = {};
  agentCCSelected = {};
  ticket: any;
  baseUrl: any;
  serviceList: any = '';
  isAccessManager = false;
  accessGrants: any[] = [];
  accessEligible: any[] = [];
  selectedEligibleUserId: any = '';
  accessScope: any = 'ticket';
  userIDCtrl: UntypedFormControl;
  empTable: any = [];
  public replyContent = '';

  public options: Object = {
    key: 'HQD1uB5B3C1A1D2E2B4E1FvfxjF1QUg1Xc2OZE1ABVJRDRNGGUH1ITrA1C7A6C5E1E4H4E1A9A8==',
    charCounterCount: true,
    attribution: false,
    height: 145,
    toolbarButtons: ['bold', 'italic', 'underline', 'align', 'undo', 'redo', 'strikeThrough',
                     'color', 'paragraphFormat', 'paragraphStyle', 'emoticons']
  };



  constructor(private activteRoute: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
        private ticketS: TicketService,
        private fb: UntypedFormBuilder,
        private adminSer: AdminTiketService,
        private userSer: UserService,
        private infoModalService: NgbModal,
        private sanitizer: DomSanitizer,
        private codeSer: CodeService,
        private clientSer: ClientService,
        private ngZone: NgZone) {

    this.showloader = false;
    this.baseUrl = environment.apiUrl;

  }

  ngOnInit() {
    this.id =  this.activteRoute.snapshot.params.id;
    const userData = localStorage.getItem('UserData');
    this.curr_user_id = JSON.parse(userData);
    this.userSer.selectMenu('askanattorney');

    this.isAccessManager = this.curr_user_id.RoleType === 8 ||
      (this.curr_user_id.RoleType === 6 && this.curr_user_id.roleprofile?.RestrictedAccess !== 1);

    this.userIDCtrl = new UntypedFormControl({value: '', disabled: true});
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.CCdropdownSettings = {
      singleSelection: false,
      idField: 'UserID',
      textField: 'EMail',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false
    };

    const isRestrictedAgent = this.curr_user_id.RoleType === 6 && this.curr_user_id.roleprofile?.RestrictedAccess === 1;
    this.form = this.fb.group ({
      keyword: '',
      assignedTo: new UntypedFormControl({value: '', disabled: isRestrictedAgent}),
      clientId: new UntypedFormControl({value: '', disabled: true}),
      userID: this.userIDCtrl,
      statusId: '',
      ticketSubject: new UntypedFormControl({value: '', disabled: true}),
      ticketSubjectMatter: new UntypedFormControl({value: '', disabled: true}),
      clientCC: new UntypedFormControl( {value: ''}),
      agentCC: ''
    });

    this.clientSer.getClients().subscribe((data: any) => {
      this.clients = data;
    });

    this.codeSer.getSubjectMatter().subscribe((data: any) => {
      this.subjects = data;
      this.applySubjectMatter();
    });

    this.userSer.getAgents().subscribe((data: any) => {
      this.assignedUser = data;
    });

    this.adminSer.getKeywords().subscribe((data: any) => {
      this.dropdownList = data;
    });

   this.activteRoute.params.subscribe(params => {
      this.id = +params['id'];
      if (this.isAccessManager) {
        this.loadTicketAccess();
      }
      this.ticketS.getSingleTickets(this.id).subscribe((data: any) => {
        const requester = data.ticket.user;
        const reqClient = requester ? requester.client : null;
        this.subject = data.ticket.subject;
        this.username = requester?.FirstName ?? 'Former user';
        this.ticket = data.ticket.id;
        this.useremail = requester?.EMail ?? '';
        this.company_name = reqClient?.ClientName || CLIENT_PLACEHOLDER;
        this.clientMissing = !reqClient;
        this.requesterMissing = !requester;
        this.requesterUserId = requester?.UserID ?? null;
        this.requesterFullName = ((requester?.FirstName || '') + ' ' + (requester?.LastName || '')).trim();
        this.company_info = reqClient?.BusinessSummary ?? '';
        this.avatar = reqClient?.Image ?? '';
        this.created_at = data.ticket.created_at;
        this.conversation = data.conversation;
        this.conversation.forEach( c => c.reply = this.sanitizer.bypassSecurityTrustHtml( c.reply ) );
        this.file_data = data.files;
        this.parseFilenames( this.file_data );
        if (reqClient?.ID) {
          this.userSer.getUsersByClient(reqClient.ID).subscribe((fData: any) => {
            this.CCemailList = fData;
            this.users = fData;
            this.clientCCSelected = this.findSelectedUsers( data.ticket.cc, fData );
          });
        }
        this.form.patchValue({
          ticketSubject: data.ticket.subject,
          ticketSubjectMatter: data.ticket.subjects?.ID ?? null,
          clientId: reqClient?.ID ?? '',
          userID: requester?.UserID ?? '',
          statusId: data.ticket.status,
          keyword: (data.ticket.tag == null) ? '' : data.ticket.tag,
          assignedTo: (data.ticket.assigned_to == null) ? null : data.ticket.assigned_to,
          clientCC: this.clientCCSelected,
          agentCC: this.agentCCSelected,
          empQuestion: data.ticket.EmpQuestion
        });
        this.ticketSubjectMatter = data.ticket.subjects || null;
        this.ticketLoaded = true;
        this.applySubjectMatter();
        this.parseEmps( data.ticket );
        if (data.ticket.EmpQuestion === 1) {
          $('#conflict').collapse( 'show' );
        }

        this.userSer.getAgents().subscribe((agentUsers: any) => {
          this.agentCCemailList = agentUsers;
          this.users = agentUsers;
          this.agentCCSelected = this.findSelectedUsers( data.ticket.cc_agent, agentUsers );
        });

        if (this.userSer.isAgentOrGreater( this.curr_user_id.UserType )) {
          this.form.get('ticketSubjectMatter').enable();
          const services = JSON.parse( reqClient?.ClientServices || '[]' ) || [];
          let serv: any = '';
          for (var idx = 0; idx < services.length; idx++ ) {
             const service = services[idx];
             if (service.ExpirationDate === undefined) {
               if (serv.length > 0 ) {
                 serv += ' ' ;
               }
               serv += service.Code;
             }
          }
          this.serviceList = serv;
        }
        this.showloader = true;
      }, (err: any) => {
        this.showloader = true;
        const status = err && err.status === false ? err.error?.status : err?.status;
        const denied = status === 403 || status === 404;
        this.displayMessage(denied ? 'You lack permission to this feature.' : 'Unable to load this ticket.');
        this.router.navigate(['/ticket']);
      });
    });
  }

  /** Selects the ticket's subject matter; a missing one shows "Not Defined", or an empty option when that code does not exist. */
  private applySubjectMatter(): void {
    if (!this.ticketLoaded || !Array.isArray(this.subjects)) {
      return;
    }
    const control = this.form.get('ticketSubjectMatter');
    const current = this.ticketSubjectMatter;
    this.subjectMatterMissing = false;
    if (current && current.ID != null) {
      if (!this.subjects.some((s: any) => s && Number(s.ID) === Number(current.ID))) {
        // Keep a real but unlisted subject matter selected so a reply never changes it silently.
        this.subjects = [...this.subjects, current];
      }
      control.setValue(current.ID, { emitEvent: false });
      return;
    }
    const notDefined = this.subjects.find((s: any) =>
      ((s && s.Value) || '').trim().toLowerCase() === SUBJECT_MATTER_PLACEHOLDER.toLowerCase());
    if (notDefined) {
      control.setValue(notDefined.ID, { emitEvent: false });
    } else {
      this.subjectMatterMissing = true;
      control.setValue('', { emitEvent: false });
    }
  }

  reopenTicket() {
    const data = new FormData();
    data.append('status', '2');
    const that = this;
    this.ticketS.updateTickets(data, this.token, this.id).subscribe(
      {
        next(fData: any) {
          that.form.value.statusId = 2;
          that.displayMessage('Your Ticket has reopened.');
        }
      }
    );
  }

  parseEmps( ticket ) {
    try {
       this.empTable = JSON.parse( ticket.EmpTable );
    } catch (e) {
       this.empTable = [];
    }
    if (this.empTable !== null && this.empTable !== undefined) {
      for (var i = 0; i < this.empTable.length; i++ ) {
        let rec = this.empTable[i];
        rec.empState = rec.empState.toUpperCase();
      }
    } else {
      this.empTable = [];
    }
  }

  findSelectedUsers( ccStr: string, userList: any ): any {
    let result = new Array();
    if (ccStr === null || ccStr === undefined || ccStr.length === 0) {
      return result;
    }
    const ccList = ccStr.split(',');

    for (var cIdx = 0; cIdx < ccList.length; cIdx++ ) {
       let cc = ccList[cIdx];
       for (var uIdx = 0; uIdx < userList.length; uIdx++ ) {
          if (cc === userList[uIdx].EMail) {
            result.push( userList[uIdx] );
          }
       }
    }
    return result;
  }

  parseFilenames( files: Array<any>) {
    this.metaFiles = [];
    for (let i = 0; i < files.length; i++ ) {
      const meta = new MetaFile( files[i].filename );

      meta.id = files[i].id;
      meta.filename = files[i].filename;
      meta.uploaded_at = files[i].uploaded_at;
      let fname: string;
      fname = files[i].filename == null ? '' : files[i].filename;
      const splitStr = fname.split( '=' );
      if (splitStr.length > 1) {
        meta.name = splitStr[1];
      } else {
        meta.name = files[i].filename;
      }

     this.metaFiles.push( meta );
    }
  }


  downloadFile(flist: MetaFile) {
    this.ticketS.downloadFile(flist.id).subscribe({
      next: (response) => {
        let filename = flist.name;
        const disposition = response.headers.get('Content-Disposition');
        if (disposition) {
          const extMatch = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
          const plainMatch = /filename="?([^";]+)"?/i.exec(disposition);
          const raw = extMatch ? extMatch[1] : (plainMatch ? plainMatch[1] : null);
          if (raw) {
            try {
              filename = decodeURIComponent(raw);
            } catch {
              filename = raw;
            }
          }
        }
        const blobUrl = window.URL.createObjectURL(response.body);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 0);
      },
      error: () => {
        this.displayMessage('Unable to download this file.');
      }
    });
  }

  getFiles(event) {
    this.files = <Array<File>>event.target.files;
    let fNames: any = '';
    for (let i = 0; i < this.files.length; i++ ) {
      if (fNames.length > 0) {
        fNames = fNames + ', ' + this.files[i].name;
      } else {
        fNames = this.files[i].name;
      }
    }
    this.custom_image_title = fNames;
    this.fileErrors = oversizedFileMessages(this.files);
    this.submitError = '';
  }

   getRequester(event) {
    const id = event.target.value;
    this.userSer.getUsersByClient(id).subscribe((data: any) => {
      this.CCemailList = data;
    });
    this.userSer.getAgents().subscribe((data: any) => {
      this.agentCCemailList = data;
      this.users = data;
    });
  }

  changeType(val) {
    this.type = val;
  }

  get f() {
    return this.form.controls;
  }

  updateForm() {
    this.submitted = true;
    this.submitError = '';
    this.fileErrors = oversizedFileMessages(this.files);
    if (this.fileErrors.length > 0) {
      return;
    }
    this.btnText = 'Replying...';
    if (this.form.invalid) {
      console.log( this.form );
      this.btnText = 'Submit';
      return;
    }
    if (this.form.valid) {
      const data = new FormData();

      let replyText;

      replyText = this.replyContent;

      if (this.files !== null) {
        for (let i = 0; i < this.files.length; i++) {
          data.append('file', this.files[i], this.files[i].name);
        }
        if (this.files.length > 0) {
          data.append( 'sendEmail', 'true' );
          let len;
          len = replyText.length;
          if (replyText.split('</p>').length > 0 && len > 4) {
            let lastfour;
            lastfour = replyText[len-4] + replyText[len-3] + replyText[len-2] + replyText[len-1];
            if (lastfour === '</p>') {
               replyText = replyText.substr(0, len-4) +
                        '<img class="paperclip" src="assets/images/file.png" alt="File Attached"></p>';
            } else {
              replyText = replyText +
                        '<p><img class="paperclip" src="assets/images/file.png" alt="File Attached"></p>';
            }
          } else {
            replyText = replyText + '<p>File attached--no reply message</p>'
                        + '<div class="paperclip"><img src="assets/images/file.png" alt="File Attached"></div>';
          }
        }
      }
      data.append('reply', replyText);

      data.append('type', this.type);
      if (this.form.value.ticketSubjectMatter) {
        data.append('subject_matter', this.form.value.ticketSubjectMatter);
      }
      if (this.form.value.agentCC) {
        data.append('cc_agent', this.userToEmailStr( this.form.value.agentCC));
      }
      if (this.form.value.clientCC) {
        data.append('cc', this.userToEmailStr( this.form.value.clientCC));
      }
      if (this.form.value.assignedTo) {
        data.append('assigned_to', this.form.value.assignedTo);
      }
      if (this.form.value.keyword) {
        // Kept local so a retry after an error still reads the selected keyword objects.
        const keywordNames = Array.prototype.map.call(this.form.value.keyword, s => s.name).toString();
        data.append('keyword', keywordNames);
      }
      if (this.form.value.clientId) {
        data.append('client_id', this.form.value.clientId);
      } else {
        data.append('client_id', this.curr_user_id.client.ID);
      }
      if (this.form.value.userID) {
        data.append('requester', this.form.value.userID);
      } else {
        data.append('requester', this.curr_user_id.UserID);
      }
      if (this.form.value.statusId) {
        data.append('status', this.form.value.statusId);
      } else {
        data.append('status', this.default_status);
      }

      const that = this;

      this.ticketS.updateTickets(data, this.token, this.id).subscribe(
      {
        next(fData: any) {
              that.showloader = false;
              that.conversation = fData.conversation;
              that.conversation.forEach( c => c.reply = that.sanitizer.bypassSecurityTrustHtml( c.reply ));
              that.btnText = 'Submit';
              that.file_data = fData.files;
              that.parseFilenames( that.file_data );
              that.replyContent = '';

              that.custom_image_title = '';
              that.files = [];
              that.submitted = false;
        },
        error(err) {
          that.ngZone.run( () => {
            that.btnText = 'Submit';
            that.submitError = apiErrorMessage(err);
          });
        }
      });
    }
  }

  userToEmailStr( ccArr ): string {
    let ccStr = '';
    for (var uIdx = 0; uIdx < ccArr.length; uIdx++ ) {
      if (ccStr.length > 0) {
        ccStr = ccStr + ',' + ccArr[uIdx].EMail;
      } else {
        ccStr = ccArr[uIdx].EMail;
      }
     }
     return ccStr;
  }

  openModal(content, conentClass) {
    this.modal = this.modalService.open(content, { windowClass: conentClass });
  }

  closeModal() {
    this.modal.close();
  }


  get eligibleToGrant() {
    const grantedIds = (this.accessGrants || []).map(g => g.user_id);
    return (this.accessEligible || []).filter(e => grantedIds.indexOf(e.user_id) === -1);
  }

  loadTicketAccess() {
    const that = this;
    this.ticketS.getTicketAccess(this.id).subscribe({
      next(data: any) {
        that.accessGrants = data.grants || [];
        that.accessEligible = data.eligible || [];
      },
      error(err) {
        that.displayMessage(that.getAccessErrorMessage(err));
      }
    });
  }

  addAccess() {
    if (!this.selectedEligibleUserId) {
      return;
    }
    const that = this;
    this.ticketS.addTicketAccess(this.id, this.selectedEligibleUserId, this.accessScope).subscribe({
      next(data: any) {
        that.selectedEligibleUserId = '';
        that.accessScope = 'ticket';
        that.loadTicketAccess();
      },
      error(err) {
        that.displayMessage(that.getAccessErrorMessage(err));
      }
    });
  }

  removeAccess(grant: any) {
    const modalRef = this.modalService.open(ModalComponent);
    modalRef.componentInstance.confirmationStr = '<p><strong>Are you sure you want to remove ' +
      '<span class="text-primary">"' + grant.first_name + ' ' + grant.last_name + '"</span> access to this ticket?</strong></p>';
    modalRef.componentInstance.title = 'Remove Attorney Access';
    const that = this;
    modalRef.result.then((res: any) => {
      that.ticketS.removeTicketAccess(that.id, grant.user_id).subscribe({
        next(data: any) {
          that.loadTicketAccess();
        },
        error(err) {
          that.displayMessage(that.getAccessErrorMessage(err));
        }
      });
    })
    .catch((res: any) => {});
  }

  getAccessErrorMessage(err: any): string {
    return (err && err.error && err.error.message) || 'Unable to complete the request.';
  }

  displayMessage( msg: any ) {
    const modalRef = this.infoModalService.open( InfoModalComponent );
    modalRef.componentInstance.confirmationStr = msg;
    modalRef.componentInstance.title = 'Heads Up';
    modalRef.result.then((res: any) => {
    });

  }

}
